module.exports = __webpack_public_path__ + "img/logo.8a5f2f43.png";